import {
  InputAdornment,
  InputBaseComponentProps,
  InputProps,
} from '@material-ui/core';
import React from 'react';

import { FieldType } from '..';
import {
  FieldTypeEnumResponse,
  ValidationTypeEnumResponse,
} from '../../../.generated/admin-api';
import { apiTranslate } from '../../../translations/translations';

export const buildNumberTextFieldInputProps = (
  field: FieldType,
): Partial<InputProps> => {
  const valueInputProps: Partial<InputProps> = {};

  const units = field.units;

  if (units) {
    valueInputProps.endAdornment = (
      <InputAdornment position="end">
        {apiTranslate(units.display)}
      </InputAdornment>
    );
  }

  const baseInputProps: InputBaseComponentProps = {};

  switch (field.fieldType) {
    case FieldTypeEnumResponse.INTEGER:
    case FieldTypeEnumResponse.KEY_VALUE_PAIR_STRING_INT: {
      baseInputProps.inputMode = 'numeric';
      break;
    }
    case FieldTypeEnumResponse.DOUBLE:
      baseInputProps.inputMode = 'decimal';
      break;
  }

  const minValueValidation = field.validationRules?.find(
    (validationRule) =>
      validationRule.type === ValidationTypeEnumResponse.MIN_VALUE,
  );
  if (minValueValidation) {
    baseInputProps.min = minValueValidation.validationValue;
  }

  const maxValueValidation = field.validationRules?.find(
    (validationRule) =>
      validationRule.type === ValidationTypeEnumResponse.MAX_VALUE,
  );
  if (maxValueValidation) {
    baseInputProps.max = maxValueValidation.validationValue;
  }

  valueInputProps.inputProps = baseInputProps;

  return valueInputProps;
};
